import { GovEmpty } from '@gov-design-system-ce/react/gov-empty';
import { GovIcon } from '@gov-design-system-ce/react/gov-icon';
import { useLocale } from '@gov-nx/core/service/translations/useLocale';
import type { ErrorStatusBannerCode } from '@gov-nx/ui/types/Banner/ErrorStatusBanner.types';

interface ErrorStatusBannerProps {
	code: ErrorStatusBannerCode;
	headline?: string;
	text?: string;
	className?: string;
}

export const ErrorStatusBanner = ({
	code,
	headline,
	text,
	className,
}: ErrorStatusBannerProps) => {
	const { t } = useLocale(code);

	return (
		<div className="p-(--templates-margin-l) bg-(--background-status-warning) rounded-(--corner-radius-l)">
			<GovEmpty
				align="center"
				size="l"
				headline={
					<p slot="headline">{headline ?? t('stav.chyba.musime-to-opravit')}</p>
				}
				icon={
					<GovIcon
						slot="icon"
						name="error"
						type="templates"
						className="bg-(--background-block-primary)!"
					/>
				}
				className={className}>
				<p className="text-(--text-primary) text-center">
					{text ?? t('stav.chyba.pracujeme-na-modernizaci')}
				</p>
			</GovEmpty>
		</div>
	);
};
